import axios from 'axios';

// Create axios instance with base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to set auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add simple response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If error is 401 Unauthorized (but not for the login request itself:
    // a failed login must be reported to the form, not treated as an
    // expired session)
    const isLoginRequest = error.config?.url?.includes('/login/');
    if (error.response?.status === 401 && !isLoginRequest) {
      // Clear authentication data
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      
      // Dispatch custom event for authentication error
      window.dispatchEvent(new Event('auth-error'));
    }
    
    // For 403 Forbidden responses (insufficient permissions)
    if (error.response?.status === 403) {
      console.error('Permission denied', error.response.data);
    }
    
    return Promise.reject(error);
  }
);

export default api;